var map = {
	"./bg_figure1.png": "6369",
	"./bg_figure2.png": "ca5c",
	"./bg_figure3.png": "0e82",
	"./bg_figure4.png": "267c",
	"./bg_figure5.png": "05ab",
	"./bg_figure6.png": "7fba",
	"./bg_figure7.png": "4d45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01c9";